import BillManagerRouterScreen from 'features/billManager/screens/BillManagerRouter/BillManagerRouterScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function BillManagerPage() {
  return (
    <PinwheelContextProvider>
      <BillManagerRouterScreen />
    </PinwheelContextProvider>
  );
}
